import { Cell } from '@table-library/react-table-library/table';
import Prompts from '../../../projects/components/prompts';
import { showPlatform } from '../../../PromptManager/keys';
import { toFixed } from '../../../../../helpers/rangeNumber';

export const COLUMNS = (t, isDark) => [
    {
        label: 'Tags',
        key: 'tag',
        data: 'tag',
        Component: Cell,
        sortType: 'string',
        className: 'big',
        cellSize: 'minmax(250px, 2.5fr)',
    },
    {
        label: 'Prompt',
        key: 'prompt',
        data: 'prompt',
        Component: Cell,
        className: 'w-100',
        cellSize: 'minmax(250px, 2.5fr)',
        style: () => {
            return { width: '100%' };
        },
        renderCell: ({ item, csvDownload }) => {
            const shownData = item.prompts ? (
                <Prompts
                    project={{}}
                    count={1}
                    trancuateSize={27}
                    showShortPrompts
                    noLink
                    data={item.prompts?.map((item) => ({ prompt: item }))}
                />
            ) : (
                t('ai_tracking.projects.labels.noData')
            );

            if (csvDownload) return shownData;

            return (
                <div className="d-flex gap-8 justify-content-between w-100">
                    <div className="w-100">{shownData}</div>
                </div>
            );
        },
    },

    {
        label: 'Checks',
        key: 'checks',
        data: 'checks',
        Component: Cell,
        sortType: (array) =>
            array.sort((a, b) => {
                const eventsA = a.promptsData?.reduce(
                    (acc, prompt) => {
                        acc.allEvents += prompt?.allEvents ?? 0;
                        return acc;
                    },
                    {
                        allEvents: 0,
                    },
                );
                const eventsB = b.promptsData?.reduce(
                    (acc, prompt) => {
                        acc.allEvents += prompt?.allEvents ?? 0;
                        return acc;
                    },
                    {
                        allEvents: 0,
                    },
                );
                const valueA = eventsA.allEvents;
                const valueB = eventsB.allEvents;
                return valueA - valueB;
            }),
        renderCell: ({ item }) => {
            const events = item.promptsData?.reduce(
                (acc, prompt) => {
                    acc.allEvents += prompt?.allEvents ?? 0;
                    return acc;
                },
                {
                    allEvents: 0,
                },
            );

            return events.allEvents ?? 0;
        },
    },
    {
        label: 'SOV',
        key: 'sov',
        data: 'sov',
        Component: Cell,
        sortType: (array) =>
            array.sort((a, b) => {
                const eventsA = a.promptsData?.reduce(
                    (acc, prompt) => {
                        acc.allEvents += prompt.allEvents ?? 0;
                        acc.ownevents += prompt.ownevents ?? 0;
                        return acc;
                    },
                    {
                        allEvents: 0,
                        ownevents: 0,
                    },
                );
                const eventsB = b.promptsData?.reduce(
                    (acc, prompt) => {
                        acc.allEvents += prompt.allEvents ?? 0;
                        acc.ownevents += prompt.ownevents ?? 0;
                        return acc;
                    },
                    {
                        allEvents: 0,
                        ownevents: 0,
                    },
                );
                const valueA = eventsA.allEvents
                    ? (eventsA.ownevents / eventsA.allEvents) * 100
                    : 0;
                const valueB = eventsB.allEvents
                    ? (eventsB.ownevents / eventsB.allEvents) * 100
                    : 0;
                return valueA - valueB;
            }),
        renderCell: ({ item }) => {
            const events = item.promptsData?.reduce(
                (acc, prompt) => {
                    acc.allEvents += prompt.allEvents ?? 0;
                    acc.ownevents += prompt.ownevents ?? 0;
                    return acc;
                },
                {
                    allEvents: 0,
                    ownevents: 0,
                },
            );

            return `${
                events.allEvents ? toFixed((events.ownevents / events.allEvents) * 100) : 0
            }%`;
        },
    },
    {
        label: 'Overall Citations Rate',
        key: 'citations_rate',
        data: 'citations_rate',
        Component: Cell,
        sortType: (array) =>
            array.sort((a, b) => {
                const eventsA = a.promptsData?.reduce(
                    (acc, prompt) => {
                        acc.ownCitations += prompt.ownCitations ?? 0;
                        acc.allCitations += prompt.allCitations ?? 0;
                        return acc;
                    },
                    {
                        ownCitations: 0,
                        allCitations: 0,
                    },
                );
                const eventsB = b.promptsData?.reduce(
                    (acc, prompt) => {
                        acc.ownCitations += prompt.ownCitations ?? 0;
                        acc.allCitations += prompt.allCitations ?? 0;
                        return acc;
                    },
                    {
                        ownCitations: 0,
                        allCitations: 0,
                    },
                );
                const valueA = eventsA.allCitations
                    ? (eventsA.ownCitations / eventsA.allCitations) * 100
                    : 0;
                const valueB = eventsB.allCitations
                    ? (eventsB.ownCitations / eventsB.allCitations) * 100
                    : 0;
                return valueA - valueB;
            }),
        renderCell: ({ item }) => {
            const events = item.promptsData?.reduce(
                (acc, prompt) => {
                    acc.ownCitations += prompt.ownCitations ?? 0;
                    acc.allCitations += prompt.allCitations ?? 0;
                    return acc;
                },
                {
                    ownCitations: 0,
                    allCitations: 0,
                },
            );

            return `${
                events.allCitations ? toFixed((events.ownCitations / events.allCitations) * 100) : 0
            }%`;
        },
    },
    {
        label: 'Citations Rate',
        key: 'chatgpt_citations_rate',
        data: 'chatgpt_citations_rate',
        Component: Cell,
        className: isDark ? 'header-platform-column-dark' : 'header-platform-column',
        sortType: (array) =>
            array.sort((a, b) => {
                const eventsA = a.promptsData?.reduce(
                    (acc, prompt) => {
                        acc.ownCitation_chatgpt += prompt.ownCitation_chatgpt ?? 0;
                        acc.allCitation_chatgpt += prompt.allCitation_chatgpt ?? 0;
                        return acc;
                    },
                    {
                        ownCitation_chatgpt: 0,
                        allCitation_chatgpt: 0,
                    },
                );
                const eventsB = b.promptsData?.reduce(
                    (acc, prompt) => {
                        acc.ownCitation_chatgpt += prompt.ownCitation_chatgpt ?? 0;
                        acc.allCitation_chatgpt += prompt.allCitation_chatgpt ?? 0;
                        return acc;
                    },
                    {
                        ownCitation_chatgpt: 0,
                        allCitation_chatgpt: 0,
                    },
                );
                const valueA = eventsA.allCitation_chatgpt
                    ? (eventsA.ownCitation_chatgpt / eventsA.allCitation_chatgpt) * 100
                    : 0;
                const valueB = eventsB.allCitation_chatgpt
                    ? (eventsB.ownCitation_chatgpt / eventsB.allCitation_chatgpt) * 100
                    : 0;
                return valueA - valueB;
            }),
        renderCell: ({ item }) => {
            const events = item.promptsData?.reduce(
                (acc, prompt) => {
                    acc.ownCitation_chatgpt += prompt.ownCitation_chatgpt ?? 0;
                    acc.allCitation_chatgpt += prompt.allCitation_chatgpt ?? 0;
                    return acc;
                },
                {
                    ownCitation_chatgpt: 0,
                    allCitation_chatgpt: 0,
                },
            );

            return `${
                events.allCitation_chatgpt
                    ? toFixed((events.ownCitation_chatgpt / events.allCitation_chatgpt) * 100)
                    : 0
            }%`;
        },
    },
    {
        label: 'Mentions Rate',
        key: 'owMentions_chatgpt',
        data: 'owMentions_chatgpt',
        className: isDark ? 'header-platform-column-dark' : 'header-platform-column',
        Component: Cell,
        sortType: (array) =>
            array.sort((a, b) => {
                const eventsA = a.promptsData?.reduce(
                    (acc, prompt) => {
                        acc.owMentions_chatgpt += prompt.owMentions_chatgpt ?? 0;
                        acc.allMentions_chatgpt += prompt.allMentions_chatgpt ?? 0;
                        return acc;
                    },
                    {
                        owMentions_chatgpt: 0,
                        allMentions_chatgpt: 0,
                    },
                );
                const eventsB = b.promptsData?.reduce(
                    (acc, prompt) => {
                        acc.owMentions_chatgpt += prompt.owMentions_chatgpt ?? 0;
                        acc.allMentions_chatgpt += prompt.allMentions_chatgpt ?? 0;
                        return acc;
                    },
                    {
                        owMentions_chatgpt: 0,
                        allMentions_chatgpt: 0,
                    },
                );
                const valueA = eventsA.allMentions_chatgpt
                    ? (eventsA.owMentions_chatgpt / eventsA.allMentions_chatgpt) * 100
                    : 0;
                const valueB = eventsB.allMentions_chatgpt
                    ? (eventsB.owMentions_chatgpt / eventsB.allMentions_chatgpt) * 100
                    : 0;
                return valueA - valueB;
            }),
        renderCell: ({ item }) => {
            const events = item.promptsData?.reduce(
                (acc, prompt) => {
                    acc.owMentions_chatgpt += prompt.owMentions_chatgpt ?? 0;
                    acc.allMentions_chatgpt += prompt.allMentions_chatgpt ?? 0;
                    return acc;
                },
                {
                    owMentions_chatgpt: 0,
                    allMentions_chatgpt: 0,
                },
            );

            return `${
                events.allMentions_chatgpt
                    ? toFixed((events.owMentions_chatgpt / events.allMentions_chatgpt) * 100)
                    : 0
            }%`;
        },
    },
    {
        label: 'Citations Rate',
        key: 'aimode_citations_rate',
        data: 'aimode_citations_rate',
        Component: Cell,
        sortType: (array) =>
            array.sort((a, b) => {
                const eventsA = a.promptsData?.reduce(
                    (acc, prompt) => {
                        acc.ownCitation_aimode += prompt.ownCitation_aimode ?? 0;
                        acc.allCitation_aimode += prompt.allCitation_aimode ?? 0;
                        return acc;
                    },
                    {
                        ownCitation_aimode: 0,
                        allCitation_aimode: 0,
                    },
                );
                const eventsB = b.promptsData?.reduce(
                    (acc, prompt) => {
                        acc.ownCitation_aimode += prompt.ownCitation_aimode ?? 0;
                        acc.allCitation_aimode += prompt.allCitation_aimode ?? 0;
                        return acc;
                    },
                    {
                        ownCitation_aimode: 0,
                        allCitation_aimode: 0,
                    },
                );
                const valueA = eventsA.allCitation_aimode
                    ? (eventsA.ownCitation_aimode / eventsA.allCitation_aimode) * 100
                    : 0;
                const valueB = eventsB.allCitation_aimode
                    ? (eventsB.ownCitation_aimode / eventsB.allCitation_aimode) * 100
                    : 0;
                return valueA - valueB;
            }),
        renderCell: ({ item }) => {
            const events = item.promptsData?.reduce(
                (acc, prompt) => {
                    acc.ownCitation_aimode += prompt.ownCitation_aimode ?? 0;
                    acc.allCitation_aimode += prompt.allCitation_aimode ?? 0;
                    return acc;
                },
                {
                    ownCitation_aimode: 0,
                    allCitation_aimode: 0,
                },
            );

            return `${
                events.allCitation_aimode
                    ? toFixed((events.ownCitation_aimode / events.allCitation_aimode) * 100)
                    : 0
            }%`;
        },
    },
    {
        label: 'Mentions Rate',
        key: 'ownMentions_aimode',
        data: 'ownMentions_aimode',
        Component: Cell,
        sortType: (array) =>
            array.sort((a, b) => {
                const eventsA = a.promptsData?.reduce(
                    (acc, prompt) => {
                        acc.ownMentions_aimode += prompt.ownMentions_aimode ?? 0;
                        acc.allMentions_aimode += prompt.allMentions_aimode ?? 0;
                        return acc;
                    },
                    {
                        ownMentions_aimode: 0,
                        allMentions_aimode: 0,
                    },
                );
                const eventsB = b.promptsData?.reduce(
                    (acc, prompt) => {
                        acc.ownMentions_aimode += prompt.ownMentions_aimode ?? 0;
                        acc.allMentions_aimode += prompt.allMentions_aimode ?? 0;
                        return acc;
                    },
                    {
                        ownMentions_aimode: 0,
                        allMentions_aimode: 0,
                    },
                );
                const valueA = eventsA.allMentions_aimode
                    ? (eventsA.ownMentions_aimode / eventsA.allMentions_aimode) * 100
                    : 0;
                const valueB = eventsB.allMentions_aimode
                    ? (eventsB.ownMentions_aimode / eventsB.allMentions_aimode) * 100
                    : 0;
                return valueA - valueB;
            }),
        renderCell: ({ item }) => {
            const events = item.promptsData?.reduce(
                (acc, prompt) => {
                    acc.ownMentions_aimode += prompt.ownMentions_aimode ?? 0;
                    acc.allMentions_aimode += prompt.allMentions_aimode ?? 0;
                    return acc;
                },
                {
                    ownMentions_aimode: 0,
                    allMentions_aimode: 0,
                },
            );

            return `${
                events.allMentions_aimode
                    ? toFixed((events.ownMentions_aimode / events.allMentions_aimode) * 100)
                    : 0
            }%`;
        },
    },
    {
        label: 'Citations Rate',
        key: 'aio_citations_rate',
        data: 'aio_citations_rate',
        Component: Cell,
        className: isDark ? 'header-platform-column-dark' : 'header-platform-column',
        sortType: (array) =>
            array.sort((a, b) => {
                const eventsA = a.promptsData?.reduce(
                    (acc, prompt) => {
                        acc.ownCitation_aio += prompt.ownCitation_aio ?? 0;
                        acc.allCitation_aio += prompt.allCitation_aio ?? 0;
                        return acc;
                    },
                    {
                        ownCitation_aio: 0,
                        allCitation_aio: 0,
                    },
                );
                const eventsB = b.promptsData?.reduce(
                    (acc, prompt) => {
                        acc.ownCitation_aio += prompt.ownCitation_aio ?? 0;
                        acc.allCitation_aio += prompt.allCitation_aio ?? 0;
                        return acc;
                    },
                    {
                        ownCitation_aio: 0,
                        allCitation_aio: 0,
                    },
                );
                const valueA = eventsA.allCitation_aio
                    ? (eventsA.ownCitation_aio / eventsA.allCitation_aio) * 100
                    : 0;
                const valueB = eventsB.allCitation_aio
                    ? (eventsB.ownCitation_aio / eventsB.allCitation_aio) * 100
                    : 0;
                return valueA - valueB;
            }),
        renderCell: ({ item }) => {
            const events = item.promptsData?.reduce(
                (acc, prompt) => {
                    acc.ownCitation_aio += prompt.ownCitation_aio ?? 0;
                    acc.allCitation_aio += prompt.allCitation_aio ?? 0;
                    return acc;
                },
                {
                    ownCitation_aio: 0,
                    allCitation_aio: 0,
                },
            );

            return `${
                events.allCitation_aio
                    ? toFixed((events.ownCitation_aio / events.allCitation_aio) * 100)
                    : 0
            }%`;
        },
    },
    {
        label: 'Mentions Rate',
        key: 'ownMentions_aio',
        data: 'ownMentions_aio',
        className: isDark ? 'header-platform-column-dark' : 'header-platform-column',
        Component: Cell,
        sortType: (array) =>
            array.sort((a, b) => {
                const eventsA = a.promptsData?.reduce(
                    (acc, prompt) => {
                        acc.ownMentions_aio += prompt.ownMentions_aio ?? 0;
                        acc.allMentions_aio += prompt.allMentions_aio ?? 0;
                        return acc;
                    },
                    {
                        ownMentions_aio: 0,
                        allMentions_aio: 0,
                    },
                );
                const eventsB = b.promptsData?.reduce(
                    (acc, prompt) => {
                        acc.ownMentions_aio += prompt.ownMentions_aio ?? 0;
                        acc.allMentions_aio += prompt.allMentions_aio ?? 0;
                        return acc;
                    },
                    {
                        ownMentions_aio: 0,
                        allMentions_aio: 0,
                    },
                );
                const valueA = eventsA.allMentions_aio
                    ? (eventsA.ownMentions_aio / eventsA.allMentions_aio) * 100
                    : 0;
                const valueB = eventsB.allMentions_aio
                    ? (eventsB.ownMentions_aio / eventsB.allMentions_aio) * 100
                    : 0;
                return valueA - valueB;
            }),
        renderCell: ({ item }) => {
            const events = item.promptsData?.reduce(
                (acc, prompt) => {
                    acc.ownMentions_aio += prompt.ownMentions_aio ?? 0;
                    acc.allMentions_aio += prompt.allMentions_aio ?? 0;
                    return acc;
                },
                {
                    ownMentions_aio: 0,
                    allMentions_aio: 0,
                },
            );

            return `${
                events.allMentions_aio
                    ? toFixed((events.ownMentions_aio / events.allMentions_aio) * 100)
                    : 0
            }%`;
        },
    },
    {
        label: 'Citations Rate',
        key: 'gemini_citations_rate',
        data: 'gemini_citations_rate',
        Component: Cell,
        sortType: (array) =>
            array.sort((a, b) => {
                const eventsA = a.promptsData?.reduce(
                    (acc, prompt) => {
                        acc.ownCitation_gemini += prompt.ownCitation_gemini ?? 0;
                        acc.allCitation_gemini += prompt.allCitation_gemini ?? 0;
                        return acc;
                    },
                    {
                        ownCitation_gemini: 0,
                        allCitation_gemini: 0,
                    },
                );
                const eventsB = b.promptsData?.reduce(
                    (acc, prompt) => {
                        acc.ownCitation_gemini += prompt.ownCitation_gemini ?? 0;
                        acc.allCitation_gemini += prompt.allCitation_gemini ?? 0;
                        return acc;
                    },
                    {
                        ownCitation_gemini: 0,
                        allCitation_gemini: 0,
                    },
                );
                const valueA = eventsA.allCitation_gemini
                    ? (eventsA.ownCitation_gemini / eventsA.allCitation_gemini) * 100
                    : 0;
                const valueB = eventsB.allCitation_gemini
                    ? (eventsB.ownCitation_gemini / eventsB.allCitation_gemini) * 100
                    : 0;
                return valueA - valueB;
            }),
        renderCell: ({ item }) => {
            const events = item.promptsData?.reduce(
                (acc, prompt) => {
                    acc.ownCitation_gemini += prompt.ownCitation_gemini ?? 0;
                    acc.allCitation_gemini += prompt.allCitation_gemini ?? 0;
                    return acc;
                },
                {
                    ownCitation_gemini: 0,
                    allCitation_gemini: 0,
                },
            );

            return `${
                events.allCitation_gemini
                    ? toFixed((events.ownCitation_gemini / events.allCitation_gemini) * 100)
                    : 0
            }%`;
        },
    },
    {
        label: 'Mentions Rate',
        key: 'ownMentions_gemini',
        data: 'ownMentions_gemini',
        Component: Cell,
        sortType: (array) =>
            array.sort((a, b) => {
                const eventsA = a.promptsData?.reduce(
                    (acc, prompt) => {
                        acc.ownMentions_gemini += prompt.ownMentions_gemini ?? 0;
                        acc.allMentions_gemini += prompt.allMentions_gemini ?? 0;
                        return acc;
                    },
                    {
                        ownMentions_gemini: 0,
                        allMentions_gemini: 0,
                    },
                );
                const eventsB = b.promptsData?.reduce(
                    (acc, prompt) => {
                        acc.ownMentions_gemini += prompt.ownMentions_gemini ?? 0;
                        acc.allMentions_gemini += prompt.allMentions_gemini ?? 0;
                        return acc;
                    },
                    {
                        ownMentions_gemini: 0,
                        allMentions_gemini: 0,
                    },
                );
                const valueA = eventsA.allMentions_gemini
                    ? (eventsA.ownMentions_gemini / eventsA.allMentions_gemini) * 100
                    : 0;
                const valueB = eventsB.allMentions_gemini
                    ? (eventsB.ownMentions_gemini / eventsB.allMentions_gemini) * 100
                    : 0;
                return valueA - valueB;
            }),
        renderCell: ({ item }) => {
            const events = item.promptsData?.reduce(
                (acc, prompt) => {
                    acc.ownMentions_gemini += prompt.ownMentions_gemini ?? 0;
                    acc.allMentions_gemini += prompt.allMentions_gemini ?? 0;
                    return acc;
                },
                {
                    ownMentions_gemini: 0,
                    allMentions_gemini: 0,
                },
            );

            return `${
                events.allMentions_gemini
                    ? toFixed((events.ownMentions_gemini / events.allMentions_gemini) * 100)
                    : 0
            }%`;
        },
    },
    {
        label: 'Citations Rate',
        key: 'preplexity_citations_rate',
        data: 'preplexity_citations_rate',
        Component: Cell,
        sortType: (array) =>
            array.sort((a, b) => {
                const eventsA = a.promptsData?.reduce(
                    (acc, prompt) => {
                        acc.ownCitation_preplexity += prompt.ownCitation_preplexity ?? 0;
                        acc.allCitation_preplexity += prompt.allCitation_preplexity ?? 0;
                        return acc;
                    },
                    {
                        ownCitation_preplexity: 0,
                        allCitation_preplexity: 0,
                    },
                );
                const eventsB = b.promptsData?.reduce(
                    (acc, prompt) => {
                        acc.ownCitation_preplexity += prompt.ownCitation_preplexity ?? 0;
                        acc.allCitation_preplexity += prompt.allCitation_preplexity ?? 0;
                        return acc;
                    },
                    {
                        ownCitation_preplexity: 0,
                        allCitation_preplexity: 0,
                    },
                );
                const valueA = eventsA.allCitation_preplexity
                    ? (eventsA.ownCitation_preplexity / eventsA.allCitation_preplexity) * 100
                    : 0;
                const valueB = eventsB.allCitation_preplexity
                    ? (eventsB.ownCitation_preplexity / eventsB.allCitation_preplexity) * 100
                    : 0;
                return valueA - valueB;
            }),
        renderCell: ({ item }) => {
            const events = item.promptsData?.reduce(
                (acc, prompt) => {
                    acc.ownCitation_preplexity += prompt.ownCitation_preplexity ?? 0;
                    acc.allCitation_preplexity += prompt.allCitation_preplexity ?? 0;
                    return acc;
                },
                {
                    ownCitation_preplexity: 0,
                    allCitation_preplexity: 0,
                },
            );

            return `${
                events.allCitation_preplexity
                    ? toFixed((events.ownCitation_preplexity / events.allCitation_preplexity) * 100)
                    : 0
            }%`;
        },
    },
    {
        label: 'Mentions Rate',
        key: 'ownMentions_perplexity',
        data: 'ownMentions_perplexity',
        Component: Cell,
        sortType: (array) =>
            array.sort((a, b) => {
                const eventsA = a.promptsData?.reduce(
                    (acc, prompt) => {
                        acc.ownMentions_perplexity += prompt.ownMentions_perplexity ?? 0;
                        acc.allMentions_perplexity += prompt.allMentions_perplexity ?? 0;
                        return acc;
                    },
                    {
                        ownMentions_perplexity: 0,
                        allMentions_perplexity: 0,
                    },
                );
                const eventsB = b.promptsData?.reduce(
                    (acc, prompt) => {
                        acc.ownMentions_perplexity += prompt.ownMentions_perplexity ?? 0;
                        acc.allMentions_perplexity += prompt.allMentions_perplexity ?? 0;
                        return acc;
                    },
                    {
                        ownMentions_perplexity: 0,
                        allMentions_perplexity: 0,
                    },
                );
                const valueA = eventsA.allMentions_perplexity
                    ? (eventsA.ownMentions_perplexity / eventsA.allMentions_perplexity) * 100
                    : 0;
                const valueB = eventsB.allMentions_perplexity
                    ? (eventsB.ownMentions_perplexity / eventsB.allMentions_perplexity) * 100
                    : 0;
                return valueA - valueB;
            }),
        renderCell: ({ item }) => {
            const events = item.promptsData?.reduce(
                (acc, prompt) => {
                    acc.ownMentions_perplexity += prompt.ownMentions_perplexity ?? 0;
                    acc.allMentions_perplexity += prompt.allMentions_perplexity ?? 0;
                    return acc;
                },
                {
                    ownMentions_perplexity: 0,
                    allMentions_perplexity: 0,
                },
            );

            return `${
                events.allMentions_perplexity
                    ? toFixed((events.ownMentions_perplexity / events.allMentions_perplexity) * 100)
                    : 0
            }%`;
        },
    },
];

export const EXTRA_COLUMNS = (t, isDark) => [
    { label: '', key: 'tag', className: 'extraHeader' },
    { label: '', key: 'prompt', className: 'extraHeader' },
    { label: '', key: 'checks', className: 'extraHeader' },
    { label: '', key: 'sov', className: 'extraHeader' },
    { label: '', key: 'citations_rate', className: 'extraHeader' },
    // ChatGPT
    {
        label: (
            <div className="ai-table-header">
                {showPlatform('chat_gpt')} {t('ai_tracking.keyword_detail.prompts.columns.chatgpt')}
            </div>
        ),
        key: 'SoV_chatgpt',
        style: () => ({
            width: '240px',
            zIndex: 3,
            backgroundColor: isDark ? '#3d3f55' : '#f7f7f7',
        }),
        className: 'extraHeader',
    },
    { label: '', key: 'ownURLs_chatgpt', className: 'extraHeader' },
    // AI Mode
    {
        label: (
            <div className="ai-table-header">
                {showPlatform('google_ai_mode')}{' '}
                {t('ai_tracking.keyword_detail.prompts.columns.google_ai_mode')}
            </div>
        ),
        key: 'SoV_aimode',
        style: () => ({
            width: '240px',
            zIndex: 3,
        }),
        className: 'extraHeader',
    },
    { label: '', key: 'ownURLs_aimode', data: 'ownURLs_aimode', className: 'extraHeader' },

    // AIO
    {
        label: (
            <div className="ai-table-header">
                {showPlatform('google_ai_overview')}{' '}
                {t('ai_tracking.keyword_detail.prompts.columns.google_ai_overview')}
            </div>
        ),
        key: 'SoV_aio',
        data: 'SoV_aio',
        style: () => ({
            width: '240px',
            zIndex: 3,
            backgroundColor: isDark ? '#3d3f55' : '#f7f7f7',
        }),
        className: 'extraHeader',
    },
    { label: '', key: 'ownURLs_aio', className: 'extraHeader' },

    // Gemini
    {
        label: (
            <div className="ai-table-header">
                {showPlatform('gemini')} {t('ai_tracking.keyword_detail.prompts.columns.gemini')}
            </div>
        ),
        key: 'SoV_gemini',
        style: () => ({
            width: '240px',
            zIndex: 3,
        }),
        className: 'extraHeader',
    },
    { label: '', key: 'ownURLs_gemini', className: 'extraHeader' },

    // Perplexity
    {
        label: (
            <div className="ai-table-header">
                {showPlatform('perplexity')}{' '}
                {t('ai_tracking.keyword_detail.prompts.columns.perplexity')}
            </div>
        ),
        key: 'SoV_perplexity',
        style: () => ({
            width: '240px',
            zIndex: 3,
        }),
        className: 'extraHeader',
    },
    {
        label: '',
        key: 'ownURLs_perplexity',
        className: 'extraHeader',
    },
];
